
import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import {useTranslation} from "react-i18next";

export default function YesNoUnbindIamsmartDialog({ open, onClose, onYes, onNo }) {
    const { t } = useTranslation();
    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="yes-no-dialog-title">
            <DialogTitle id="yes-no-dialog-title"></DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t("common.iamsmart.yesOrNoUnbind")}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onYes} color="success" autoFocus>
                    {t("common.confirm")}
                </Button>
                <Button onClick={onNo} color="success">
                    {t("common.cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}